import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useSurveys from '@helsenorge/framework-utils/additional-page-content/useSurveys';
import { setSurveysCookie } from '@helsenorge/framework-utils/additional-page-content/utils';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import FeedbackPanelWrapper from './feedbackpanel-wrapper';
import { useAppSelector } from '../store/hooks';
import UxSignalsWrapper from '../uxsignals-wrapper';
import styles from './styles.module.scss';
/**
 * Viser undersøkelser for en bestemt plassering på siden som FeedbackPanel.
 */
const FeedbackPanelContainer = props => {
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    const { data: unansweredSurveys, isLoading } = useSurveys({ languageCode: language, position: props.position });
    const panelSurveys = unansweredSurveys?.filter(survey => survey.component === 'panel-static' || survey.component === 'panel-expander');
    const surveys = panelSurveys?.filter(survey => survey._type === 'survey');
    const uxSignalSurveys = panelSurveys?.filter(survey => survey._type === 'uxsignals');
    const handleClose = (id) => {
        setSurveysCookie(id);
    };
    if (isLoading) {
        return null;
    }
    if (surveys?.length === 0 && uxSignalSurveys?.length === 0) {
        return null;
    }
    // Ikke vis invitasjonen under automatiserte tester (f.eks. Playwright)
    if (navigator.webdriver) {
        return null;
    }
    return (_jsxs("div", { className: styles.feedbackpanelcontainer, "data-testid": "feedback-panel-container", children: [surveys?.map(survey => {
                if (survey.component === 'panel-static') {
                    return _jsx(FeedbackPanelWrapper, { survey: survey, variant: "static", onClose: handleClose }, survey.id);
                }
                else if (survey.component === 'panel-expander') {
                    return _jsx(FeedbackPanelWrapper, { survey: survey, variant: "expander", onClose: handleClose }, survey.id);
                }
            }), uxSignalSurveys?.map(survey => {
                return _jsx(UxSignalsWrapper, { survey: survey }, survey.id);
            })] }));
};
export default FeedbackPanelContainer;
